import { Tooltip } from 'antd';
import {
  useCallback,
  useRef,
  useState,
  type CSSProperties,
  type ReactNode,
} from 'react';

interface ShipmentOverflowTooltipProps {
  text: string;
  className?: string;
  style?: CSSProperties;
  children?: ReactNode;
  targetSelector?: string;
}

const ShipmentOverflowTooltip = ({
  text,
  className,
  style,
  children,
  targetSelector,
}: ShipmentOverflowTooltipProps) => {
  const ref = useRef<HTMLSpanElement | null>(null);
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState<string | undefined>();

  const handleMouseEnter = useCallback(() => {
    const root = ref.current;
    const target = targetSelector
      ? root?.querySelector<HTMLElement>(targetSelector)
      : root;
    const shouldShow = Boolean(
      text && target && target.scrollWidth > target.clientWidth
    );

    setTitle(shouldShow ? text : undefined);
    setOpen(shouldShow);
  }, [targetSelector, text]);

  const handleMouseLeave = () => {
    setOpen(false);
    setTitle(undefined);
  };

  return (
    <Tooltip title={title} open={open} destroyOnHidden placement='top'>
      <span
        ref={ref}
        className={className}
        style={style}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {children ?? text}
      </span>
    </Tooltip>
  );
};

export default ShipmentOverflowTooltip;
